/**
 * My Tasks Page (Epic 3 — Toewijzing met tijdspercentages en tijdvakken,
 * Story 3.2 Task 4)
 *
 * Read-only weergave van het eigen kerntakenpakket voor rol `medewerker`
 * (UX-spec S8). Was tot deze story een placeholder zonder databinding.
 * `user.employeeId` komt al mee via `/auth/me` (zelfde patroon als
 * `EmployeeDashboard.tsx`'s `user?.employeeId`).
 */

import { Layout } from '../../components/Layout';
import { useAuth } from '../auth';
import { useCurrentPackage } from './useAssignmentPeriods';
import { useCoreTasks } from '../settings/useCoreTasks';
import { CurrentPackageCard } from './components/CurrentPackageCard';

export function MyTasksPage() {
  const { user } = useAuth();
  const employeeId = user?.employeeId ?? undefined;

  const { currentPackage, isLoading } = useCurrentPackage(employeeId);
  const { data: coreTasks } = useCoreTasks(false);

  const skillsByCoreTaskId = (coreTasks ?? []).reduce<Record<number, string[]>>((acc, task) => {
    acc[task.id] = task.skills.map((s) => s.label);
    return acc;
  }, {});

  return (
    <Layout>
      <div data-testid="my-tasks-page" className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Mijn kerntaken</h1>
          <p className="mt-1 text-sm text-gray-500">
            Dit zijn de kerntaken waarop je wordt beoordeeld en hoe zwaar elk onderdeel weegt.
          </p>
        </div>

        {employeeId === undefined ? (
          <div className="bg-white p-6 rounded-lg border border-[#E2E8F0] text-sm text-gray-500">
            Geen medewerkerprofiel gekoppeld aan dit account. Neem contact op met HR.
          </div>
        ) : (
          <CurrentPackageCard
            currentPackage={currentPackage}
            isLoading={isLoading}
            readOnly={true}
            skillsByCoreTaskId={skillsByCoreTaskId}
          />
        )}
      </div>
    </Layout>
  );
}
